// src/utils/describeError.ts
// Human-readable, non-minified error details for logging and error states.
import axios from "axios";

export interface ErrorInfo {
  message: string;
  status?: number;
  url?: string;
  /** True when the server answered 404 "nothing here", i.e. a real empty state. */
  notFound: boolean;
  /** True when the request never got a response (offline, DNS, CORS). */
  network: boolean;
}

export function describeError(err: unknown): ErrorInfo {
  if (axios.isAxiosError(err)) {
    const status = err.response?.status;
    const serverMsg = (err.response?.data as any)?.message;
    return {
      message: serverMsg || err.message,
      status,
      url: err.config?.url,
      notFound: status === 404,
      network: !err.response,
    };
  }
  const e = err as { message?: string } | null;
  return { message: e?.message || String(err), notFound: false, network: false };
}

export function logError(scope: string, err: unknown): ErrorInfo {
  const info = describeError(err);
  // eslint-disable-next-line no-console
  console.error(`[${scope}] ${info.message}`, { status: info.status, url: info.url });
  return info;
}
